/**
 * @public
 */
export class Requirement {
    _type;
    _uri;
    constructor(type, uri) {
        this._type = type;
        this._uri = uri;
    }
    get type() {
        return this._type;
    }
    get uri() {
        return this._uri;
    }
    equals(value) {
        return value instanceof Requirement && value.uri === this.uri;
    }
    toJSON() {
        return {
            type: this._type,
            uri: this._uri,
        };
    }
    toEARL() {
        return {
            "@context": {
                earl: "http://www.w3.org/ns/earl#",
            },
            "@type": ["earl:TestCriterion", "earl:TestRequirement"],
            "@id": this.uri,
        };
    }
}
/**
 * @public
 */
(function (Requirement) {
    function isRequirement(value) {
        return value instanceof Requirement;
    }
    Requirement.isRequirement = isRequirement;
})(Requirement || (Requirement = {}));
//# sourceMappingURL=requirement.js.map